import { SCREENS } from "./catalog";
import type { ScreenId } from "./catalog";

const path = (id: ScreenId): string => SCREENS.find((s) => s.id === id)?.path ?? "/admin/money";

/** DUE-535: the 11 pre-six-screens tab paths; bot links (`/admin_web`) and bookmarks still use them. */
export const LEGACY_ADMIN_REDIRECTS: readonly (readonly [from: string, to: string])[] = [
  ["/admin/economics", path("money")],
  ["/admin/usage", path("service")],
  ["/admin/products", path("money")],
  ["/admin/llm-config", path("texts-ai")],
  ["/admin/app-config", path("texts-ai")],
  ["/admin/flags", path("features")],
  ["/admin/free-tier", path("money")],
  ["/admin/users", path("people")],
  ["/admin/feedback", path("people")],
  ["/admin/generations", path("texts-ai")],
  ["/admin/audit-log", path("service")],
];

export const ADMIN_HOME = path("money");
